import React from 'react'
import {MenuLink} from '@src/modules/Layout/shared/MenuLink'
import {EVENTS_ROUTES} from '../../constants'
import {useCurrentEventCounts} from '@src/modules/Events/hooks/useCurrentEventCounts'
import {Badge, Icon} from '@therms/atalaya'
import {useCurrentUser} from '@therms/react-modules'
import {MdBolt} from 'react-icons/md'

function EventsMenuLink() {
  const currentUser = useCurrentUser()
  const {counts} = useCurrentEventCounts({})
  const {counts: userCounts} = useCurrentEventCounts({
    assignedUserIdFilter: [currentUser.id],
  })

  return (
    <MenuLink to={EVENTS_ROUTES.__ROOT__}>
      <div className="flex w-full items-center justify-between">
        <div className="gap-x-sm inline-flex items-center">
          <Icon Icon={MdBolt} />

          <span>Events</span>
        </div>

        <span className="space-x-xs">
          <Badge value={counts.pending} variant="caution" />

          <Badge value={userCounts.active} variant="main" />
        </span>
      </div>
    </MenuLink>
  )
}

export {EventsMenuLink}